/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FuelUpGameAdminActionRequest
 */
export interface FuelUpGameAdminActionRequest {
    /**
     * 
     * @type {string}
     * @memberof FuelUpGameAdminActionRequest
     */
    action: FuelUpGameAdminActionRequestActionEnum;
    /**
     * Target user ID (required for user-specific actions)
     * @type {string}
     * @memberof FuelUpGameAdminActionRequest
     */
    userId?: string;
    /**
     * Fuel amount for adjustments
     * @type {number}
     * @memberof FuelUpGameAdminActionRequest
     */
    amount?: number;
    /**
     * Admin reason for the action
     * @type {string}
     * @memberof FuelUpGameAdminActionRequest
     */
    reason?: string;
}


/**
 * @export
 */
export const FuelUpGameAdminActionRequestActionEnum = {
    reset_user_game: 'reset_user_game',
    adjust_user_fuel: 'adjust_user_fuel',
    force_vault_evolution: 'force_vault_evolution',
    grant_prestige_bonus: 'grant_prestige_bonus'
} as const;
export type FuelUpGameAdminActionRequestActionEnum = typeof FuelUpGameAdminActionRequestActionEnum[keyof typeof FuelUpGameAdminActionRequestActionEnum];


/**
 * Check if a given object implements the FuelUpGameAdminActionRequest interface.
 */
export function instanceOfFuelUpGameAdminActionRequest(value: object): value is FuelUpGameAdminActionRequest {
    if (!('action' in value) || value['action'] === undefined) return false;
    return true;
}

export function FuelUpGameAdminActionRequestFromJSON(json: any): FuelUpGameAdminActionRequest {
    return FuelUpGameAdminActionRequestFromJSONTyped(json, false);
}

export function FuelUpGameAdminActionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelUpGameAdminActionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'action': json['action'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function FuelUpGameAdminActionRequestToJSON(json: any): FuelUpGameAdminActionRequest {
    return FuelUpGameAdminActionRequestToJSONTyped(json, false);
}

export function FuelUpGameAdminActionRequestToJSONTyped(value?: FuelUpGameAdminActionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'action': value['action'],
        'userId': value['userId'],
        'amount': value['amount'],
        'reason': value['reason'],
    };
}

